import { isNotDefined } from '@sgme/fp';
import { useFieldValidationError } from 'components/common-form/hooks/useFieldValidationError';
import { useFormattedFormGroupLabel } from 'components/shared/FormGroup/useFormatFormGroupLabel';

import type { CommonFormGroupProps } from './model';
import { VerticalFormGroupComponent } from './VerticalFormGroupComponent';

export function VerticalFormGroup<T extends string = string>({
  inputId,
  label,
  labelText,
  labelContent,
  children,
  className,
  labelClassName,
  workspaceType,
  tooltipKey,
  errorPrefix,
}: CommonFormGroupProps<T>) {
  const validationError = useFieldValidationError(
    inputId,
    isNotDefined(errorPrefix) ? 'quote.errorMessages.' : errorPrefix,
  );
  const txt = useFormattedFormGroupLabel({ inputId, label, workspaceType });
  return (
    <VerticalFormGroupComponent
      inputId={inputId}
      className={className}
      labelClassName={labelClassName}
      labelText={labelText ?? txt}
      labelContent={labelContent}
      validationError={validationError}
      tooltipKey={tooltipKey}
    >
      {children}
    </VerticalFormGroupComponent>
  );
}

VerticalFormGroup.displayName = 'VerticalFormGroup';
